import { render } from "./Container3.vue?vue&type=template&id=65847e56&ts=true"
import script from "./Container3.vue?vue&type=script&lang=ts"
export * from "./Container3.vue?vue&type=script&lang=ts"

import "./Container3.vue?vue&type=style&index=0&id=65847e56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__